import Cross from "@/assets/icons/svg/close-icon-white.svg";
import { mapGetters, mapActions } from "vuex";
import HeaderLinkCard from './header-card-link/header-card-link'
// import HeaderCodeCard from './header-code-card/header-code-card'
import HeaderStatusCard from './header-status-card/header-status-card'
import HeaderCreditComponent from './header-credits-component/header-credits-component'
import HeaderGraph from './header-graph/header-graph'
import ModalContent from "@shared/modal-content"
import Input from "@/components/input"
import axios from "@/axios";
import backendaxios from "../light-ray/axios";
import PendingActions from "@shared/components/pending-actions"
import SupportCenter from "@shared/components/supportCenter"
import { DateTime } from "luxon";
import LihgtRayHeaderGraph from "@shared/assets/lgtr-header-graph.svg"
import EditPencil from "@shared/assets/edit-pencil.svg"

export default {
  name: "app-header",
  components: {
    Cross,
    HeaderLinkCard,
    // HeaderCodeCard,
    ModalContent,
    Input,
    PendingActions,
    HeaderStatusCard,
    LihgtRayHeaderGraph,
    EditPencil,
    HeaderCreditComponent,
    HeaderGraph,
    SupportCenter,
  },
  props: {
    notificationCount:{
      type:Number,
      default:0
    },
    showNotifications:{
      type:Boolean,
      default: true
    },
    statusUpdatePermission:{
      type:Boolean,
      default: false
    },
    setInitialPageBranding: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      caseDescription: "",
      review_date: "",
      onHold: "",
      onHoldDate: "",
      reason: "",
      caseStatus: this.getCaseStatusList,
      activeState: null,
      statusMenuOpen: false,
      showStatus: false,
      duration: 0,
      creditScore:"",
      listData:[],
      primaryCreditPack:"",
      adminUser: false,
      isChangeCaseStatus: false,
      oldStatusValue: {},
      previousCaseStatus: false,
      currentCheckStatus: {},
      supportModalOpen: false,
      // showDuration: false
    };
  },
  computed: {
    ...mapGetters(["getCaseData", "getUser", "getCaseStatusList", "getTenantId", "getLoginTenantDetails"]),
    creditlist() {
      return this.listData;
    },
    userName() {
      return this.getUser ? this.getUser.user_name : ' '
    },
    tenantData() {
      return this.getTenantId ? this.getTenantId : ''
    },
    appTitle(){
      return this.$route.meta.title || ''
    },
    showCaseInfo(){
      return this.$route.meta.showCaseInfo
    },
    caseId(){
     return this.$route.query.case_id
    },
    showLightRay(){
      return this.$route.meta.showLightRay
    },
    getButtonInfoText() {
      return "Save Case status"
    },
    getDaysRemaing() {
      if (this.getCaseData.due_date) {
        const formatDate = (date) => DateTime.fromISO(date).toFormat("dd MMM yyyy");
        let day_remaining = 0
        let today = new Date()
        let due_date = new Date(this.getCaseData.due_date)
        day_remaining = Math.ceil((due_date.getTime() - today.getTime() ) / (1000 * 3600 * 24))
        this.getCaseData.due_date = formatDate(this.getCaseData?.due_date);
        if (day_remaining > 0) return  day_remaining + ' Days'
        else return `Already passed ${Math.abs(day_remaining)} days ago`
      } else return '--'
    }
  },
    async mounted() {
      this.fetchTenantDetails();
      this.fetchClaseDetails();
      // const url = "user-credit-pack/get_user_credit_packs"
      // const data = await backendaxios.get(url);
      // const primaryCreditPackData = data?.find((item) => item.primary === true);
      // this.creditScore = (1-(primaryCreditPackData.used)/primaryCreditPackData.issued_credits) * 100;
      // const listUrl = "api/v1/source-consume-callback/get_user_credit_packs"
      // this.listData = await axios.get(listUrl);
      // this.primaryCreditPack = this.listData.find((item) => item.id === primaryCreditPackData.id).name
    },
  watch : {  
    showCaseInfo:async function(val) {  
      if(val){
        this.fetchClaseDetails();
        console.log('val :>> ', val);
      }
    }, 
    tenantData:async function(val) {
      if(val) {
        this.fetchTenantDetails();
        console.log('val :>> ', val);
      }
    },
    activeState(newVal, oldVal) {
      this.oldStatusValue = oldVal;
      console.log("new value :>>", newVal);
    }
  },
  methods: {
    ...mapActions(["fetchCaseData", "fetchCaseStatusLists", "setTenantDetails"]),
    async getCredit() {
      const url = "user-credit-pack/get_user_credit_packs"
      const data = await backendaxios.get(url);
      return data;
    },
    getCaseName(){
      return sessionStorage.getItem('case_name') || this.$route.query.name
    },
    handleCloseModal(status_value) {
      this.$refs['header-modal'].hideModal(status_value);
    },
    async fetchTenantDetails() {
      try {
        if (this.getTenantId) {
          const tenantData  = await axios.get(`/tenant/${this.getTenantId}`);
          this.adminUser = tenantData?.data?.is_admin;
          this.$store.dispatch("setTenantDetails", tenantData?.data);

          // This is workaround to prevent document.title reset
          // That is caused by fetchTenantDetails method
          if (this.setInitialPageBranding) {
            this.$brandPage(this.$route);
          }
        }
      } catch (error) {
        if (Array.isArray(error?.response?.data?.detail)) {
          this.$toast.error(error?.response?.data?.detail?.[0]?.msg);
        } else {
          this.$toast.error(error?.response?.data?.detail);
        }
      }
    },
    async fetchClaseDetails(){
        let case_id = this.$route.query.caseid
        if(case_id){
            await this.fetchCaseData(case_id)
            await this.fetchCaseStatusLists()
            let caseStatus = {
                id: this.getCaseData.case_status_id,
                name: this.getCaseData.case_status_name,
                color: this.getCaseData.case_status_color
            }
            this.activeState = caseStatus
            this.currentCheckStatus = this.activeState;
        }
    },
    handleShowModal(value) {
      // switch (value) {
      //   case "onHold":
      //     this.$refs['head-modal'].show(value);
      //     break;
      //   case "resume":
      //     this.$refs['head-modal'].show(value);
      //     break;
      //   case "rejectCase":
      //     this.$refs['head-modal'].show(value);
      //     break;
      //   default:
      //     console.log(`Sorry, we are out of ${value}.`);
      // }
      if (value) {
          this.reason = ""
          this.$refs['header-modal'].showModal(value);
      } else return
    },
    setActiveStatus(status) {
        this.activeState = status;
    },
    async handleStatusClick(status) {
        this.previousCaseStatus = false;
        this.setActiveStatus(status)
        this.setShowStatus()
        if(status.reason_mandatory){
          this.handleShowModal(status.name) 
        }else{
            await this.handleChangeCaseStatus(status)
        }
    },

    async handleChangeCaseStatus(status){
      this.previousCaseStatus = false;
        if(this.reason === '' && status.reason_mandatory ){
            this.$toast.error('reason required');
            return
        } else if ( this.duration <= 0 && status.internal_name === 'ON_HOLD') {
          this.$toast.error('Please enter duration in days (must be greater than zero)');
          return
        }
        else{
            let case_id = this.$route.query.caseid
            const url = `/case/${case_id}/status`;
            let payload = {
                "status": status.id,
                "reason": this.reason
            }
            if (status.internal_name === 'ON_HOLD') {
              payload.duration = parseInt(this.duration)
            }
            try {
                let { data } = await axios.post(url, payload);
                this.$toast.success(data.message || 'case status updated');
                this.setShowStatus()
                this.handleCloseModal()
                this.reason = ""
                this.duration = 0
                this.currentCheckStatus = status
            } catch (error) {
                this.$toast.warning(error.response.message || 'failed to change case status');
            }
            
        }
    },

    clickOutside() {
      this.showStatus = false
    },

    setShowStatus() {
      this.showStatus = !this.showStatus;
    },
    logout() {
      this.$store.dispatch("logoutUser");
    },
    setPreviousCaseStatus(val) {
      val ? this.previousCaseStatus = val : this.previousCaseStatus = false
    }
  },
};
